import { render } from "./Turntable.vue?vue&type=template&id=78e487bf"
import script from "./Turntable.vue?vue&type=script&lang=js"
export * from "./Turntable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__